export enum PortfolioModalRoutes {
	BasePath = "portfolio-modal",
	PortfolioPerformanceNotice = "performance-notice",
	PortfolioCrossSellingInformation = "cross-selling-information"
}
